export enum BidStatuses {
  REQUESTED = "requested",
  DRAFT = "draft",
  SUBMITTED = "submitted",
  AWARDED = "awarded",
  REJECTED = "rejected",
}
